import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const IntentProjectsTableDescriptionCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={intentProject.description} />
    </TableSimpleCell>
  );
};

export default IntentProjectsTableDescriptionCell;
